// extracted by mini-css-extract-plugin
export var animationContainer = "_i8-0";
export var asteriskIcon = "_i8-8";
export var conversationLeftSection = "_i8-4";
export var conversationListItem = "_i8-3";
export var conversationMiddleSection = "_i8-5";
export var conversationRightSection = "_i8-6";
export var detailsContent = "_i8-1";
export var listContainer = "_i8-7";
export var modalContent = "_i8-2";